export default "__VITE_PUBLIC_ASSET__5ab20b1e__"